export const devConsoleLog = (name: string, content: any) => {
    if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.log('[Dev console log]', name, content)
    }
}

export const isDevelopment = false

export const isProductionEnvironment = true

export const isTranslationModeEnabled = localStorage.getItem('isTranslationModeEnabled') === 'true'
